import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { SettingsProvider } from "./contexts/SettingsContext";
import PublicLayout from "./components/layout/PublicLayout";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import ProductDetail from "./pages/ProductDetail";
import Reserve from "./pages/Reserve";
import RepairQuote from "./pages/RepairQuote";
import Appointment from "./pages/Appointment";
import Quiz from "./pages/Quiz";
import Plans from "./pages/Plans";
import Services from "./pages/Services";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import AdminProducts from "./pages/admin/AdminProducts";
import AdminRequests from "./pages/admin/AdminRequests";
import AdminPrices from "./pages/admin/AdminPrices";
import AdminReviews from "./pages/admin/AdminReviews";
import AdminPlans from "./pages/admin/AdminPlans";
import AdminGallery from "./pages/admin/AdminGallery";
import AdminSettings from "./pages/admin/AdminSettings";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SettingsProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/catalogue" element={<Catalog />} />
                <Route path="/produit/:id" element={<ProductDetail />} />
                <Route path="/reserver/:id" element={<Reserve />} />
                <Route path="/reparation" element={<RepairQuote />} />
                <Route path="/rendez-vous" element={<Appointment />} />
                <Route path="/quiz" element={<Quiz />} />
                <Route path="/forfaits" element={<Plans />} />
                <Route path="/services" element={<Services />} />
                <Route path="/galerie" element={<Gallery />} />
                <Route path="/contact" element={<Contact />} />
              </Route>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="produits" element={<AdminProducts />} />
                <Route path="demandes" element={<AdminRequests />} />
                <Route path="tarifs" element={<AdminPrices />} />
                <Route path="forfaits" element={<AdminPlans />} />
                <Route path="avis" element={<AdminReviews />} />
                <Route path="galerie" element={<AdminGallery />} />
                <Route path="reglages" element={<AdminSettings />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="top-center" />
        </SettingsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
